<template>
  <radio-group-facade v-model="model" class="radio-list">
    <radio-facade
      v-for="(item, index) in items"
      :key="index"
      :value="item.value"
    >
      {{ item.label }}
    </radio-facade>
  </radio-group-facade>
</template>

<script setup>
  import { defineModel } from 'vue';
  import RadioGroupFacade from '@/lib/ant-design-vue/components/RadioGroupFacade.vue';
  import RadioFacade from '@/lib/ant-design-vue/components/RadioFacade.vue';

  const model = defineModel();

  defineProps({
    // Список в формате [{value, label}]
    items: {
      type: Array,
      required: true,
    },
  });
</script>

<style lang="scss" scoped>

</style>